import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import SupplierProfile from './SupplierProfile'
import Users from './Users'

const Admin = () => {
  const routes = [
    {
      navLabel: 'Supplier Profile',
      path: '/admin/supplier-profile',
      component: SupplierProfile,
    },
    {
      navLabel: 'Users',
      path: '/admin/users',
      component: Users,
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default Admin
